import { useApi } from '~/composables/useApi'
import { useSupabaseClient } from '~/composables/useSupabaseClient'
import type { LocationAccount, LocationAccountWithInfo } from '~/entities/locationAccount'

export const getLocationAccountEmail = async (
  organizationName: string,
  accountName: string
): Promise<LocationAccount['email'] | null> => {
  const { client } = useApi()
  const response = await client.locationAccountEmail.$get({
    query: { organizationName, accountName },
  })

  if (!response.ok) {
    const body = await response.text()
    throw new Error(
      `Failed to get location account email: ${response.status} ${response.statusText}: ${body}`
    )
  }
  const { email } = await response.json()
  return email
}

export const getLocationAccountById = async (id: string): Promise<LocationAccountWithInfo> => {
  const { data, error } = await useSupabaseClient()
    .from('location_accounts')
    .select('*, organizations!inner(*), locations!inner(*)')
    .eq('id', id)
    .single()
  if (error) throw error
  if (!data.organizations || !data.locations) throw new Error('No data returned')
  return {
    ...data,
    organization: data.organizations,
    location: data.locations,
  }
}
